import {
  Breadcrumb,
  Button,
  Col,
  Input,
  Layout,
  Row,
  Select,
  Upload,
  message,
} from 'antd'
import React, { useEffect, useState } from 'react'
import OAMSider from '../oam-sider'
import { Content } from 'antd/lib/layout/layout'
import styles from './index.module.less'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import GlobalCss from '@/global.module.less'
import * as constanst from '../../../constants/constants'
import Cookies from 'js-cookie'
import { sendHttpPostRequest } from '@/api/http-request'
import { useHistory, useLocation, useParams } from 'react-router-dom'

const OAMLogoManageForm = () => {
  const [imageUrl, setImageUrl] = useState('')
  const [loading, setLoading] = useState(false)
  const [styleOpts, setStyleOpts] = useState([] as any)
  const [selectedStyle, setSelectedStyle] = useState<any>()
  const [logoName, setLogoName] = useState('')
  const location = useLocation()
  const params: any = useParams()
  const history = useHistory()
  const editMode = location.pathname.includes('edit')

  useEffect(() => {
    getStyleOpts()
    if (editMode) {
      getLogoInfo()
    }
    return () => {}
  }, [])

  const getLogoInfo = () => {
    let data = {
      logo_id: params?.logoId,
    }
    sendHttpPostRequest('course/api/oam_logo_detail', data, (res) => {
      if (res.code == 0) {
        setImageUrl(res.data.image_path)
        setLogoName(res.data.name)
        let lab: any = res.data.style.label
        setSelectedStyle({
          label: lab,
          value: JSON.stringify(res.data.style.value),
        })
      }
    })
  }

  const getStyleOpts = () => {
    sendHttpPostRequest('course/api/oam_logo_style_list', {}, (res) => {
      setStyleOpts(
        res.data.map((s) => ({
          label: s.label,
          value: JSON.stringify(s.value),
        }))
      )
    })
  }

  const beforeUpload = (file: any) => {
    const isJpgOrPng =
      file.type === 'image/jpeg' ||
      file.type === 'image/png' ||
      file.type == 'image/svg+xml'
    if (!isJpgOrPng) {
      message.error('只能上传image或png或svg图片')
    }
    const isLt2M = file.size / 1024 / 1024 < 30
    if (!isLt2M) {
      message.error('图片大小不能超过 30MB!')
    }
    return isJpgOrPng && isLt2M
  }

  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true)
      return
    }
    if (info.file.status === 'done') {
      console.log('info', info)
      let res = info.file.response
      setImageUrl(res.data.file_path)

      // Get this url from response in real world.
      // getBase64(info.file.originFileObj as RcFile, url => {
      //   setLoading(false);
      //   setImageUrl(url);
      // });
    }
  }

  const styleSelectChange = (val, info) => {
    setSelectedStyle(info.label)
  }

  const onSaveLogoInfo = () => {
    if (!imageUrl) {
      message.error('请上传背景图')
      return
    }
    let data: any
    if (editMode) {
      data = {
        logo_id: params?.logoId,
        name: logoName,
        style: selectedStyle,
        image_path: imageUrl,
      }
    } else {
      data = {
        name: logoName,
        style: selectedStyle,
        image_path: imageUrl,
      }
    }

    sendHttpPostRequest('course/api/oam_edit_logo_info', data, (res) => {
      if (res.code == 0) {
        history.push('/oam_logo_manager')
      }
    })
  }

  const logoNameChange = (e) => {
    setLogoName(e.target.value)
  }

  const uploadButton = (
    <div>
      {loading ? (
        <LoadingOutlined />
      ) : (
        <Row align={'middle'} className={GlobalCss.tipText}>
          <Col>
            <PlusOutlined />
          </Col>
          <Col>请上传背景图</Col>
        </Row>
      )}
    </div>
  )

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <OAMSider keys={'logo—manager'} openKeys={[]}></OAMSider>
      <Layout style={{ backgroundColor: '#f9f9f9' }}>
        <Content
          style={{
            position: 'relative',
            backgroundColor: '#fff',
            borderRadius: 5,
            minWidth: 400,
            margin: '60px 30px 0px 30px',
            paddingTop: 20,
          }}
        >
          <Breadcrumb style={{ marginLeft: 0, float: 'left', marginTop: -60 }}>
            <Breadcrumb.Item>
              <a href="/oam_logo_manager">Logo配置</a>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span style={{ fontWeight: 500 }}>
                {' '}
                {editMode ? '编辑' : '新建'}{' '}
              </span>
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className={styles.formContent}>
            <Row align="middle" className={styles.formRow} wrap={false}>
              <Col className={styles.formName}>名称</Col>
              <Col flex={'70%'}>
                <Input
                  onChange={logoNameChange}
                  value={logoName}
                  placeholder="请输入logo名称，不超过30字符"
                />
              </Col>
            </Row>
            <Row align="middle" className={styles.formRow}>
              <Col className={styles.formName}>名称样式</Col>
              <Col flex={'35%'}>
                <Select
                  value={selectedStyle}
                  options={styleOpts}
                  style={{ width: '100%' }}
                  placeholder="选择名称样式"
                  onChange={styleSelectChange}
                />
              </Col>
            </Row>
            <Row align={'top'} className={styles.formRow} wrap={false}>
              <Col className={styles.requireLabel}>背景图</Col>
              <Col flex={1}>
                <Upload
                  name="image"
                  data={{
                    sessionid: Cookies.get('sessionid'),
                  }}
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  action={
                    constanst.BACKEND_API_URL + 'course/api/oam_upload_logo'
                  }
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                >
                  {imageUrl ? (
                    <img
                      src={constanst.BACKEND_API_URL + imageUrl}
                      alt="avatar"
                      style={{ width: '100%' }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload>
                <div className={GlobalCss.tipText}>
                  注意：图片大小不得超过30MB
                </div>
              </Col>
            </Row>
          </div>
          <Row
            align={'middle'}
            justify="center"
            className={styles.createFooter}
          >
            <Col>
              <Button onClick={() => history.push('/oam_logo_manager')}>
                取消
              </Button>
            </Col>
            <Col>
              <Button onClick={onSaveLogoInfo} type="primary">
                保存
              </Button>
            </Col>
          </Row>
        </Content>
      </Layout>
    </Layout>
  )
}

export default OAMLogoManageForm
